import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Env from "../../runtimeEnv";
import Navbar from "../../components/Navbar";
import useTherapistRoster from "../../hooks/useTherapistRoster";

export default function AdminRegisterUser() {
  const { therapists, rosterLoading, rosterError } = useTherapistRoster();
  const [userType, setUserType] = useState("Client");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const submit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = Object.fromEntries(new FormData(form));
    setLoading(true);
    setMessage(null);

    try {
      const response = await axios.post(
        `${Env.REACT_APP_PYTHON_API_URL}/api/admin/register-user`,
        data,
        { withCredentials: true }
      );
      setMessage({ success: true, text: response.data.message });
      form.reset();
      setUserType("Client");
    } catch (error) {
      setMessage({
        success: false,
        text: error.response?.data?.message ||
          "Unable to register user. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="mt-20 admin-container">
        <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">
            Register User
          </h2>
          <Link to="/admin" className="text-blue-600 hover:underline">
            ← Back to admin
          </Link>
          {message && (
            <p role="status" className={message.success ? "text-green-600" : "text-red-600"}>
              {message.text}
            </p>
          )}
          <form onSubmit={submit} className="space-y-4">
            <label className="block font-medium">
              User type
              <select
                name="userType"
                value={userType}
                onChange={(event) => setUserType(event.target.value)}
                className="input-field"
              >
                <option value="Client">Client</option>
                <option value="Therapist">Therapist</option>
              </select>
            </label>
            <label className="block font-medium">
              First name
              <input name="firstName" autoComplete="given-name" required className="input-field" />
            </label>
            <label className="block font-medium">
              Last name
              <input name="lastName" autoComplete="family-name" required className="input-field" />
            </label>
            <label className="block font-medium">
              Email
              <input name="email" type="email" autoComplete="email" required className="input-field" />
            </label>
            {userType === "Client" && (
              <label className="block font-medium">
                Assigned therapist
                {rosterLoading && <p role="status">Loading therapists…</p>}
                {rosterError && <p role="alert">{rosterError}</p>}
                <select name="assignedTherapist" required defaultValue="" className="input-field">
                  <option value="">Select a Therapist</option>
                  {therapists.map((therapist) => (
                    <option key={therapist.email} value={therapist.email}>
                      {therapist.name}
                    </option>
                  ))}
                </select>
              </label>
            )}
            <button type="submit" disabled={loading || (userType === "Client" && (rosterLoading || Boolean(rosterError)))} className="button-primary">
              {loading ? "Registering..." : "Register User"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
